import '.i{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.o{text-align:center;}.ssr-plugin'
import '.a0{margin:6rem auto 3rem;}.ssr-plugin'
import { styled } from 'inlines'
import { PageLayout } from '../layout/PageLayout'
import notFoundImage from '@app/assets/images/error/not-found.svg'
import { Image } from '@app/components/core/image/Image'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'

export const NotFoundPage = () => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.error
  const contentStyle = isMobile
    ? { minWidth: '17rem', gap: '1rem' }
    : { maxWidth: '40rem', gap: '2.5rem' }
  const imageStyle = { width: isMobile ?   '17rem' : 'auto' }
  const BodyText = isMobile ? Text.Medium : Text.Large

  return (
    <PageLayout>
      <div className="i m j n o a0"
      >
        <styled.div className="i m n"
          style={{
            ...contentStyle,
          }}
        >
          <Image src={notFoundImage} alt={t.imageAlt} style={imageStyle} />
          <Title.H2 style={{ marginBottom: 0 }}>{t.notFoundTitle}</Title.H2>
          <BodyText>{t.notFoundMessage}</BodyText>
        </styled.div>
      </div>
    </PageLayout>
  )
}
